import React, { useEffect } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import Helmet from 'react-helmet'
import { useLocale } from '../../../extensions/Locale/useLocale'
import POconstants from '../../../Utils/POconstants'

const AboutUs = (props: RouteComponentProps) => {
    const { lang, currentLang } = useLocale<Locale.Keys>()
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <div className="pageContent aboutUs">
            <Helmet>
                <meta name="description" content={lang.pageDescription} />
                <meta charSet="utf-8" />
                <title>{lang.titles.aboutUs}</title>
                <link rel="alternate" hrefLang="hr" href={POconstants.siteLinks.aboutUs}></link>
                <link rel="alternate" hrefLang="en" href={POconstants.siteLinks.aboutUs + '?lang=en'}></link>
                <link rel="alternate" hrefLang="x-default" href={POconstants.siteLinks.aboutUs + '?lang=en'}></link>
                <link rel="canonical" href={POconstants.siteLinks.aboutUs + currentLang === 'en' ? '?lang=en' : ''} />
            </Helmet>
            <h2>{lang.pages.aboutUs.h2_1}</h2>
            <p>{lang.pages.aboutUs.p1}</p>
            <a href="http://www.dalmatian-nature.hr/" target="_blank" rel="noopener noreferrer">
                {POconstants.externalLinks.JUSeaAndKarst}
            </a>
            <h2>{lang.pages.aboutUs.h2_2}</h2>
            <p>{lang.pages.aboutUs.p2_1}</p>
            <p>
                {lang.pages.aboutUs.p2_2_1}
                <em>{lang.pages.aboutUs.p2_2_2}</em>
                {lang.pages.aboutUs.p2_2_3}
            </p>
            <h2>{lang.pages.aboutUs.h2_3}</h2>
            <p>{lang.pages.aboutUs.p3_1}</p>
            <p>{lang.pages.aboutUs.p3_2}</p>
            <p>{lang.pages.aboutUs.p3_3}</p>
            <ul style={{ margin: 0 }}>
                <li>
                    <p>{lang.pages.aboutUs.p3_4}</p>
                </li>
                <li>
                    <p>{lang.pages.aboutUs.p3_5}</p>
                </li>
            </ul>
            <p>{lang.pages.aboutUs.p3_6}</p>
        </div>
    )
}

export default AboutUs
